import _ from 'lodash'

// return value page static content
export function returnValue(key, manifest, content) {
  // console.log('returnValue', key)
  // console.log(content[key])
  // console.log('---')

  if (manifest[key]?.value === undefined) {
    // if key is not found - don't error
    console.warn('ISSUE - key not found...', key, manifest, content)
    return false
  } else {
    return content[key] ? content[key] : manifest[key].value

    // if (content[key] == undefined) {
    //   return manifest[key].value
    // } else {
    //   return content[key]
    // }
  }
}

// return value of block content value
export function returnBlockValue(key, type, manifest, content) {
  if (manifest[type][key]?.value === undefined) {
    // if key is not found - don't error
    console.warn('ISSUE - BLOCK key not found...', key, manifest, content)
    return false
  } else {
    return content[key] ? content[key] : manifest[type][key].value
  }
}

// return user content
export function returnUserContent(key, id, data) {
  if (_.isEmpty(data)) {
    return ''
  } else {
    // console.log(data[id])
    return data[id]?.[key]
  }
}
